import inView from 'in-view'

export default function inViewCustom() {
	inView.offset(50);

	inView(('.in-view')).on('enter', el => {
		let animation = el.getAttribute('data-animation')
		let delay = el.getAttribute('data-delay')

		if (delay) {
			setTimeout(() => {
				el.classList.add(animation)
			}, delay)
		} else {
			el.classList.add(animation)
		}
	});
}